import * as React from 'react'
import { ValueContainerProps, components } from 'react-select'
import { PositionSelectOption } from '../position-select.types'

export const ValueContainer = (
  props: ValueContainerProps<PositionSelectOption, false>
) => (
  <components.ValueContainer {...props} className="py-1 min-h-[40px] gap-y-2" />
)
